export default "__VITE_ASSET__Bpky$mne__"